/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateUnproxiedMcpServerForm,
  CreateUnproxiedMcpServerForm$Outbound,
  CreateUnproxiedMcpServerForm$outboundSchema,
} from "../components/createunproxiedmcpserverform.js";

export type CreateUnproxiedMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateUnproxiedMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateUnproxiedMcpServerSecurity = {
  option1?: CreateUnproxiedMcpServerSecurityOption1 | undefined;
  option2?: CreateUnproxiedMcpServerSecurityOption2 | undefined;
};

export type CreateUnproxiedMcpServerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createUnproxiedMcpServerForm: CreateUnproxiedMcpServerForm;
};

/** @internal */
export type CreateUnproxiedMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateUnproxiedMcpServerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    CreateUnproxiedMcpServerSecurityOption1$Outbound,
    CreateUnproxiedMcpServerSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createUnproxiedMcpServerSecurityOption1ToJSON(
  createUnproxiedMcpServerSecurityOption1:
    CreateUnproxiedMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    CreateUnproxiedMcpServerSecurityOption1$outboundSchema.parse(
      createUnproxiedMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateUnproxiedMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateUnproxiedMcpServerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    CreateUnproxiedMcpServerSecurityOption2$Outbound,
    CreateUnproxiedMcpServerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function createUnproxiedMcpServerSecurityOption2ToJSON(
  createUnproxiedMcpServerSecurityOption2:
    CreateUnproxiedMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    CreateUnproxiedMcpServerSecurityOption2$outboundSchema.parse(
      createUnproxiedMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateUnproxiedMcpServerSecurity$Outbound = {
  Option1?: CreateUnproxiedMcpServerSecurityOption1$Outbound | undefined;
  Option2?: CreateUnproxiedMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateUnproxiedMcpServerSecurity$outboundSchema: z.ZodMiniType<
  CreateUnproxiedMcpServerSecurity$Outbound,
  CreateUnproxiedMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateUnproxiedMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateUnproxiedMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createUnproxiedMcpServerSecurityToJSON(
  createUnproxiedMcpServerSecurity: CreateUnproxiedMcpServerSecurity,
): string {
  return JSON.stringify(
    CreateUnproxiedMcpServerSecurity$outboundSchema.parse(
      createUnproxiedMcpServerSecurity,
    ),
  );
}

/** @internal */
export type CreateUnproxiedMcpServerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateUnproxiedMcpServerForm: CreateUnproxiedMcpServerForm$Outbound;
};

/** @internal */
export const CreateUnproxiedMcpServerRequest$outboundSchema: z.ZodMiniType<
  CreateUnproxiedMcpServerRequest$Outbound,
  CreateUnproxiedMcpServerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createUnproxiedMcpServerForm: CreateUnproxiedMcpServerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createUnproxiedMcpServerForm: "CreateUnproxiedMcpServerForm",
    });
  }),
);

export function createUnproxiedMcpServerRequestToJSON(
  createUnproxiedMcpServerRequest: CreateUnproxiedMcpServerRequest,
): string {
  return JSON.stringify(
    CreateUnproxiedMcpServerRequest$outboundSchema.parse(
      createUnproxiedMcpServerRequest,
    ),
  );
}
